import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = { class: "row w-full justify-between flex items-center flex-shrink-0" }
const _hoisted_3 = { class: "flex flex-row-reverse items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "mt-5 flex flex-col flex-1 min-h-0 overflow-hidden" }
const _hoisted_7 = { class: "px-5 pb-5 card w-full relative mapping-tabs-shell min-h-0" }
const _hoisted_8 = { class: "table-section mt-5 min-h-0 flex-1 overflow-hidden" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "flex justify-center mt-5 text-xs"
}
const _hoisted_12 = { class: "flex items-center justify-between py-4 px-2 rounded" }
const _hoisted_13 = { class: "pl-2" }
const _hoisted_14 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_15 = { class: "formcontainer flex flex-col" }
const _hoisted_16 = { class: "row flex flex-row w-full" }
const _hoisted_17 = { class: "row flex flex-row w-full" }
const _hoisted_18 = { class: "w-6/12" }
const _hoisted_19 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_20 = { class: "w-3/6 leftspacing" }
const _hoisted_21 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_22 = { class: "row flex flex-row w-full" }
const _hoisted_23 = { class: "w-6/12" }
const _hoisted_24 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_25 = { class: "w-3/6 leftspacing" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "row flex flex-row w-full" }
const _hoisted_29 = { class: "w-6/12" }
const _hoisted_30 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_31 = { key: 1 }
const _hoisted_32 = { class: "w-3/6 leftspacing" }
const _hoisted_33 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_38 = { class: "row flex flex-row w-full" }
const _hoisted_39 = { class: "w-full" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "row flex flex-row w-full" }
const _hoisted_44 = { class: "w-full" }
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "row flex flex-row w-full" }
const _hoisted_49 = { class: "w-full" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "row flex flex-row w-full" }
const _hoisted_54 = { class: "w-full" }
const _hoisted_55 = {
  key: 0,
  class: "mb-3 mt-2 text-sm"
}
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "row flex flex-row w-full" }
const _hoisted_58 = { class: "w-full" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = { class: "mb-3 mt-2 text-sm" }
const _hoisted_61 = { class: "row flex flex-row w-full" }
const _hoisted_62 = { class: "w-full" }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { class: "mb-3 mt-2 text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tab = _resolveComponent("Tab")!
  const _component_TabList = _resolveComponent("TabList")!
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Tabs = _resolveComponent("Tabs")!
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("h1", { class: "title" }, "Library", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["flex", !_ctx.columnObject ? 'filterButton' : 'filterButtondisabled pointer-events-none']),
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.columnObject)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[3] || (_cache[3] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-xs mt-3 flex-shrink-0" }, " This page displays the organization’s control library, including both internal controls and controls from adopted external compliance frameworks. ", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_ctx.visibleTabs.length)
          ? (_openBlock(), _createBlock(_component_Tabs, {
              key: 0,
              value: _ctx.selectedFrame,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedFrame) = $event)),
              scrollable: "",
              class: "mt-5 h-full min-h-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_TabList, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleTabs, (tab, tabIndex) => {
                      return (_openBlock(), _createBlock(_component_Tab, {
                        key: tabIndex,
                        value: tab.value,
                        onClick: ($event: any) => (_ctx.toggleTabs(tab.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(tab.displayName), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_tableData, {
                    class: "flex-1 min-h-0",
                    tableRowData: _ctx.tableRow,
                    headersData: _ctx.headers,
                    loadData: _ctx.dataLoading
                  }, null, 8, ["tableRowData", "headersData", "loadData"]),
                  (_ctx.toolTipActive)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["value"]))
          : (_ctx.dataLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_dots_loader)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_11, " No Records Found ")),
        (_ctx.popUpFrameWork)
          ? (_openBlock(), _createBlock(_component_popup, {
              key: 3,
              popUp: _ctx.popUpFrameWork
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h1", _hoisted_13, _toDisplayString(_ctx.frameworkObj.controlFrameWork || 'Internal Controls'), 1),
                  _createElementVNode("button", {
                    class: "float-right text-3xl",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCancelbtn()))
                  }, _cache[5] || (_cache[5] = [
                    _createElementVNode("img", {
                      src: _imports_2,
                      class: "h-5 w-5 cursor-pointer"
                    }, null, -1)
                  ]))
                ])
              ]),
              default: _withCtx(() => [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Number", -1)),
                                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.frameworkObj?.controlNumber || 'N/A'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _cache[7] || (_cache[7] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Title", -1)),
                                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.frameworkObj?.controlTitle || 'N/A'), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Type", -1)),
                              _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.frameworkObj?.controlType || 'N/A'), 1)
                            ]),
                            _createElementVNode("div", _hoisted_25, [
                              (_ctx.checkType())
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, _cache[9] || (_cache[9] = [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("label", { class: "text-xs font-extrabold" }, "Priority"),
                                      _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, "N/A")
                                    ], -1)
                                  ])))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dbPriority, (dataValue, indexNum) => {
                                    return (_openBlock(), _createElementBlock("div", { key: indexNum }, [
                                      (_ctx.frameworkObj.controlPriority == dataValue.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _cache[10] || (_cache[10] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Priority", -1)),
                                            (dataValue!=undefined)
                                              ? (_openBlock(), _createElementBlock("div", {
                                                  key: 0,
                                                  class: _normalizeClass(["flex items-center justify-center rounded h-5 w-24 mt-2", _ctx.colorLabelBg(dataValue.value)])
                                                }, [
                                                  _createElementVNode("div", {
                                                    class: _normalizeClass(["text-xs", _ctx.colorLabelText(dataValue.value)])
                                                  }, _toDisplayString(_ctx.getProirityLabel(dataValue.value)), 3)
                                                ], 2))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("div", _hoisted_29, [
                              _cache[12] || (_cache[12] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Family", -1)),
                              (_ctx.frameworkObj.controlFamily != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _toDisplayString(_ctx.frameworkObj.controlFamily), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_31, _cache[11] || (_cache[11] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                            ]),
                            _createElementVNode("div", _hoisted_32, [
                              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Class", -1)),
                              (_ctx.frameworkObj.controlClass != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_33, _toDisplayString(_ctx.frameworkObj.controlClass), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_34, _cache[13] || (_cache[13] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            (_ctx.frameworkObj.controlFrequency == null || _ctx.frameworkObj.controlFrequency==undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _cache[15] || (_cache[15] = [
                                  _createElementVNode("div", null, [
                                    _createElementVNode("label", { class: "text-xs font-extrabold" }, "Frequency"),
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, "N/A")
                                  ], -1)
                                ])))
                              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.dbFrequency, (dataValue) => {
                                  return (_openBlock(), _createElementBlock("div", { key: dataValue }, [
                                    (_ctx.frameworkObj.controlFrequency == dataValue.value)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                          _cache[16] || (_cache[16] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Frequency", -1)),
                                          (dataValue!=undefined)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(dataValue.key), 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      : _createCommentVNode("", true)
                                  ]))
                                }), 128))
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("div", _hoisted_39, [
                              _cache[18] || (_cache[18] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Description", -1)),
                              (_ctx.frameworkObj.Description != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                    _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.frameworkObj.Description), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_42, _cache[17] || (_cache[17] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("div", _hoisted_44, [
                              _cache[20] || (_cache[20] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Tasks", -1)),
                              (_ctx.frameworkObj.controlMaintenanceTask != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                    _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.frameworkObj.controlMaintenanceTask), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_47, _cache[19] || (_cache[19] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _cache[22] || (_cache[22] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Policies", -1)),
                              (_ctx.frameworkObj.controlPolicies != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, _toDisplayString(_ctx.frameworkObj.controlPolicies), 1)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_52, _cache[21] || (_cache[21] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_53, [
                            _createElementVNode("div", _hoisted_54, [
                              _cache[24] || (_cache[24] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Guidance", -1)),
                              (_ctx.frameworkObj.controlGuidance != null)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_55, _toDisplayString(_ctx.frameworkObj.controlGuidance), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_56, _cache[23] || (_cache[23] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("div", _hoisted_58, [
                              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "text-xs font-extrabold" }, "Frameworks", -1)),
                              (_ctx.controlFrameWorks.length==0 )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, _cache[25] || (_cache[25] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.controlFrameWorks, (dataValue) => {
                                    return (_openBlock(), _createElementBlock("div", { key: dataValue }, [
                                      _createElementVNode("div", _hoisted_60, _toDisplayString(dataValue.framework), 1)
                                    ]))
                                  }), 128))
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            _createElementVNode("div", _hoisted_62, [
                              _cache[28] || (_cache[28] = _createElementVNode("label", { class: "text-xs font-extrabold" }, " Controls Mapped", -1)),
                              (_ctx.controlFrameWorks.length==0 )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_63, _cache[27] || (_cache[27] = [
                                    _createElementVNode("div", { class: "mb-3 mt-2 text-sm" }, _toDisplayString('N/A'), -1)
                                  ])))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.controlFrameWorks, (dataValue) => {
                                    return (_openBlock(), _createElementBlock("div", { key: dataValue }, [
                                      _createElementVNode("div", _hoisted_64, _toDisplayString(dataValue.controls[0]), 1)
                                    ]))
                                  }), 128))
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["popUp"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}